import { useMemo } from 'react'
import { useWorld } from '../contexts/WorldDataContext'
import { getNpc } from '../data/guide/npcs'
import { resolveNpcLocation, type NpcLocation } from '../utils/npcLocation'

/** Ubicación resuelta de un NPC con la lógica común de toda la guía. */
export function useNpcLocation(npcId: string): NpcLocation | undefined {
  const world = useWorld()
  return useMemo(() => {
    const npc = getNpc(npcId)
    return npc ? resolveNpcLocation(npc, { status: world.status, data: world.data, error: world.error }) : undefined
  }, [npcId, world.status, world.data, world.error])
}
